export default __webpack_public_path__ + "static/media/icon858.f618d3e5.svg";